export const handlePrint = e => {
  e.preventDefault();
  const bodyElement = document.getElementsByTagName('body')[0];

  bodyElement.classList.add('printing');
  window.print();
  bodyElement.classList.remove('printing');
};
